// extracted by mini-css-extract-plugin
export default {"contacts":"CompactContacts_contacts__DnNmH","address":"CompactContacts_address__eHKBu","phones":"CompactContacts_phones__1SIt+"};